const { Serializer } = require("jsonapi-serializer");

module.exports = {
  RejectRequestRejectionSerializer: (meta = {}) =>
    new Serializer("store", {
      meta,
      pluralizeType: false,
      keyForAttribute: "snake_case",
      attributes: ["issuerPaymentId", "token"]
    })
};
